import  { useState, useEffect } from 'react';
import  domain  from '../../../reusecomponent/domain';
import { getToken } from '../../function/token';
import { SuccessToastContainer, ErrorToastContainer } from '../../function/CustomFunction';
import Preloader from '../preloader';


const PaymentConfiguration = () => {
  const [formData, setFormData] = useState({
    payment_gateway: 'razorpay',
    payment_accept_type: 'both',
    merchant_id: '',
    secret_key: '',
    key_id: '',
    is_active: true
  });
  
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchPaymentConfiguration();
  }, []);

  const fetchPaymentConfiguration = async () => {
    setLoading(true);
    try {
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        }
      };

      const response = await fetch(`${domain()}/payment-configration`, requestOptions);
      const data = await response.json();
      
      if (response.ok && data.status) {
        setFormData({
          payment_gateway: data.data.payment_gateway_name ? data.data.payment_gateway_name.toLowerCase() : 'razorpay',
          payment_accept_type: data.data.payment_accept_type || 'both',
          merchant_id: data.data.merchant_id || '',
          secret_key: data.data.secret_key || '',
          key_id: data.data.key_id || '',
          is_active: data.data.is_active === 1 || data.data.is_active === true
        });
      }
    } catch (error) {
      console.error('Error fetching payment configuration:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => {
      const newData = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      };
      
      // Clear key_id when switching to PhonePe
      if (name === 'payment_gateway' && value === 'phonepe') {
        newData.key_id = '';
      }
      
      return newData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      // Transform data to match API expected format
      const apiData = {
        payment_gateway: formData.payment_gateway.charAt(0).toUpperCase() + formData.payment_gateway.slice(1),
        payment_accept_type: formData.payment_accept_type,
        merchant_id: formData.merchant_id,
        secret_key: formData.secret_key,
        is_active: formData.is_active ? 1 : 0
      };

      // Only include key_id for Razorpay
      if (formData.payment_gateway === 'razorpay') {
        apiData.key_id = formData.key_id;
      }

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        },
        body: JSON.stringify(apiData)
      };

      const response = await fetch(`${domain()}/payment-configration`, requestOptions);
      const data = await response.json();

      if (response.ok && data.status) {
        SuccessToastContainer('Payment configuration saved successfully!');
      } else {
        ErrorToastContainer(data.message || 'Failed to save payment configuration');
      }
    } catch (error) {
      console.error('Error saving payment configuration:', error);
      ErrorToastContainer('An error occurred while saving the configuration');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Preloader action={loading} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-panel w-100 p-0 px-3" style={{minHeight: '100vh', background: '#f7f8fa'}}>
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Payment Configuration</h4>
            <p className="card-description">Configure your payment gateway settings</p>
            
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="payment_gateway">Payment Gateway</label>
                    <select
                      className="form-control"
                      id="payment_gateway"
                      name="payment_gateway"
                      value={formData.payment_gateway}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="razorpay">Razorpay</option>
                      <option value="phonepe">PhonePe</option>
                    </select>
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="payment_accept_type">Payment Accept Type</label>
                    <select
                      className="form-control"
                      id="payment_accept_type"
                      name="payment_accept_type"
                      value={formData.payment_accept_type}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="UPL">Upi Payment Link</option>
                      <option value="SPL">Standard Payment Link</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="merchant_id">Merchant ID</label>
                    <input
                      type="text"
                      className="form-control"
                      id="merchant_id"
                      name="merchant_id"
                      value={formData.merchant_id}
                      onChange={handleInputChange}
                      placeholder="Enter merchant ID"
                      required
                    />
                  </div>
                </div>
                
                {formData.payment_gateway === 'razorpay' && (
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="key_id">Key ID</label>
                      <input
                        type="text"
                        className="form-control"
                        id="key_id"
                        name="key_id"
                        value={formData.key_id}
                        onChange={handleInputChange}
                        placeholder="Enter Razorpay key ID"
                        required
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="secret_key">Secret Key</label>
                    <input
                      type="password"
                      className="form-control"
                      id="secret_key"
                      name="secret_key"
                      value={formData.secret_key}
                      onChange={handleInputChange}
                      placeholder="Enter secret key"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                   <label htmlFor="secret_key">Secret Key</label>
                      <select
                        type=""
                        className="form-control"
                        id="is_active"
                        name="is_active"
                        value={formData.is_active}
                        onChange={handleInputChange}
                      >
                      <option value="true">Active</option>
                      <option value="false">Inactive</option>
                      </select>
                    
                  </div>
                </div>
              </div>

              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-primary mr-2"
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                      Saving...
                    </>
                  ) : (
                    'Save Configuration'
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => window.location.reload()}
                  disabled={saving}
                >
                  Reset
                </button>
              </div>
            </form>

            <div className="mt-4">
              <div className="alert alert-info">
                <h6><strong>Configuration Guide:</strong></h6>
                <ul className="mb-0">
                  <li><strong>Razorpay:</strong> Enter your Razorpay Key ID, Secret Key, and Merchant ID from your Razorpay dashboard</li>
                  <li><strong>PhonePe:</strong> Enter your PhonePe Merchant ID and Secret Key from your PhonePe business dashboard</li>
                  <li><strong>Payment Accept Type:</strong> Choose whether to accept online payments, offline payments, or both</li>
                  <li><strong>Status:</strong> Enable or disable the payment gateway functionality</li>
                  {formData.payment_gateway === 'razorpay' && (
                    <li className="text-primary"><strong>Note:</strong> Key ID field is required for Razorpay integration</li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
    </div>
  );

  return (
    <div className="row">
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Payment Configuration</h4>
            <p className="card-description">Configure your payment gateway settings</p>
            
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="payment_gateway">Payment Gateway</label>
                    <select
                      className="form-control"
                      id="payment_gateway"
                      name="payment_gateway"
                      value={formData.payment_gateway}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="razorpay">Razorpay</option>
                      <option value="phonepe">PhonePe</option>
                    </select>
                  </div>
                </div>
                
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="payment_accept_type">Payment Accept Type</label>
                    <select
                      className="form-control"
                      id="payment_accept_type"
                      name="payment_accept_type"
                      value={formData.payment_accept_type}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="UPL">Upi Payment Link</option>
                      <option value="SPL">Standard Payment Link</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="merchant_id">Merchant ID</label>
                    <input
                      type="text"
                      className="form-control"
                      id="merchant_id"
                      name="merchant_id"
                      value={formData.merchant_id}
                      onChange={handleInputChange}
                      placeholder="Enter merchant ID"
                      required
                    />
                  </div>
                </div>
                
                {formData.payment_gateway === 'razorpay' && (
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="key_id">Key ID</label>
                      <input
                        type="text"
                        className="form-control"
                        id="key_id"
                        name="key_id"
                        value={formData.key_id}
                        onChange={handleInputChange}
                        placeholder="Enter Razorpay key ID"
                        required
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="secret_key">Secret Key</label>
                    <input
                      type="password"
                      className="form-control"
                      id="secret_key"
                      name="secret_key"
                      value={formData.secret_key}
                      onChange={handleInputChange}
                      placeholder="Enter secret key"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                   <label htmlFor="secret_key">Secret Key</label>
                      <select
                        type=""
                        className="form-control"
                        id="is_active"
                        name="is_active"
                        value={formData.is_active}
                        onChange={handleInputChange}
                      >
                      <option value="true">Active</option>
                      <option value="false">Inactive</option>
                      </select>
                    
                  </div>
                </div>
              </div>

              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-primary mr-2"
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                      Saving...
                    </>
                  ) : (
                    'Save Configuration'
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => window.location.reload()}
                  disabled={saving}
                >
                  Reset
                </button>
              </div>
            </form>

            <div className="mt-4">
              <div className="alert alert-info">
                <h6><strong>Configuration Guide:</strong></h6>
                <ul className="mb-0">
                  <li><strong>Razorpay:</strong> Enter your Razorpay Key ID, Secret Key, and Merchant ID from your Razorpay dashboard</li>
                  <li><strong>PhonePe:</strong> Enter your PhonePe Merchant ID and Secret Key from your PhonePe business dashboard</li>
                  <li><strong>Payment Accept Type:</strong> Choose whether to accept online payments, offline payments, or both</li>
                  <li><strong>Status:</strong> Enable or disable the payment gateway functionality</li>
                  {formData.payment_gateway === 'razorpay' && (
                    <li className="text-primary"><strong>Note:</strong> Key ID field is required for Razorpay integration</li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentConfiguration;